module.exports = __webpack_public_path__ + "img/liuliang.9dce6ca7.png";